module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-pagination', {
    ref: "pagination",
    attrs: {
      "background": _vm.showBackground,
      "layout": _vm.pageData.total > _vm.pageData.per_page ? 'prev, pager, jumper, next, total' : 'total',
      "hide-on-single-page": _vm.hideOnSinglePage,
      "pager-count": _vm.pageCount,
      "total": _vm.pageData.total,
      "page-count": _vm.pageData.last_page
    },
    on: {
      "prev-click": function($event) {
        return _vm.loadPage('prev')
      },
      "next-click": function($event) {
        return _vm.loadPage('next')
      },
      "current-change": _vm.onChangePage
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c7ca14a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/tables/DataTablePagination.vue
// module id = 1518
// module chunks = 0